export const userData = {
  id: 1,
  username: "Ben88",
  rating: {
    5: 342,
    4: 18,
    3: 15,
    2: 6,
    1: 44,
  },
};
